<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M72 512c0-19.3 15.6-34.9 34.9-34.9h108c19.2 0 34.9 15.6 34.9 34.9 0 19.2-15.6 34.9-34.9 34.9h-108C87.6 546.9 72 531.2 72 512zm0-162.1c0-19.2 15.6-34.9 34.9-34.9h108c19.2 0 34.9 15.6 34.9 34.9 0 19.2-15.6 34.9-34.9 34.9h-108c-19.3 0-34.9-15.6-34.9-34.9z" data-follow-fill="currentColor" :fill="_fill" />
      <path d="M241.9 952C178 952 126 900 126 836v-27c0-4.3 3.5-7.9 7.9-7.9h54c4.3 0 7.9 3.5 7.9 7.9 0 19.6 7.6 37.9 21.5 51.8 13.8 13.8 32.2 21.4 51.8 21.4h532.4c44.7 0 81-36.3 81-81V214.9c0-40.3-32.8-73.1-73.2-73.2H268.9c-19.6 0-37.9 7.6-51.8 21.4-13.8 13.8-21.4 32.2-21.4 51.8 0 4.3-3.5 7.9-7.9 7.9h-54c-4.3 0-7.9-3.5-7.9-7.9v-27c0-31 12-60.1 33.9-81.9 21.9-22 51-34 81.9-34H836c64 0 116 51.9 116 115.8V836c0 63.8-51.9 115.8-115.8 115.9H241.9z" data-follow-fill="currentColor" :fill="_fill" />
      <path d="M674 708.9c-4.3 0-7.8-3.5-7.9-7.8-.9-69.2-58-125.5-127.2-125.5s-126.3 56.3-127.2 125.5c-.1 4.3-3.6 7.8-7.9 7.8h-54c-4.3 0-7.9-3.5-7.9-7.9 0-35.9 9.8-71.2 28.4-101.9 15.1-24.9 35.4-46.1 59.5-62.1 4-2.7 4.7-8.2 1.5-11.8-22.7-25.9-35.5-59.3-35.5-94.2 0-38.2 14.8-74.1 41.8-101.1s62.9-41.8 101-41.8c38.2 0 74.1 14.9 101.1 41.8 27 27 41.9 62.9 41.9 101.1.1 35-12.7 68.4-35.5 94.2-3.2 3.6-2.5 9.1 1.5 11.8 54.7 36.3 87.9 97.4 88 164 0 4.3-3.5 7.9-7.9 7.9H674zM539 357.8c-19.5 0-37.9 7.6-51.7 21.4-13.8 13.8-21.4 32.2-21.4 51.7 0 40.3 32.8 73.2 73.1 73.2s73.2-32.8 73.2-73.1c0-19.6-7.6-37.9-21.4-51.8-13.9-13.8-32.2-21.4-51.8-21.4zM72 674c0-19.3 15.6-34.9 34.9-34.9h108c19.2 0 34.9 15.6 34.9 34.9 0 19.2-15.6 34.9-34.9 34.9h-108C87.6 708.9 72 693.2 72 674z" data-follow-fill="currentColor" :fill="_fill" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
